import { ServiceResponse } from "../ServiceResponse";

export class SetLastAccessResponse extends ServiceResponse
{
  public LastAccess: any;
}
